"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateViaKey = exports.stringToLocale = exports.sortByPropCaseInsensitive = exports.shortenText = exports.scrollTo = exports.removeNumberFormatting = exports.ramdaMapIndexed = exports.parseURLFromText = exports.noop = exports.media = exports.isTouchDevice = exports.isSwipeDisabled = exports.isMobile = exports.isLengthSmallerThan = exports.isLengthGreaterThan = exports.hasSpecialCharacters = exports.hasOnlyWhiteSpaces = exports.hasOnlySpecialCharacters = exports.hasDecimalsWithinValue = exports.getSize = exports.getNumberSeparatorsForLocale = exports.getErrorStatus = exports.getErrorMessage = exports.getCountryCode = exports.formatNumber = exports.floor = exports.decimalTransform = exports.debounce = exports.convertDecimalToPercentage = exports.ceil = exports.betaFeaturePrefix = exports.actionCreators = exports.WARNING_SIGN_OUT_TIME_SECONDS = exports.TYPES = exports.SIZE_UNIT = exports.REGEXP_MAP = exports.FILE_ENCODING = exports.DEFAULT_TIME_OUT = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _styledComponents = require("styled-components");
var _config = _interopRequireDefault(require("@trs/config"));
var _objects = require("../objects");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var breakpoints = _config["default"].breakpoints,
  breakpointsNumeric = _config["default"].breakpointsNumeric,
  UNITS = _config["default"].UNITS,
  MAX_DECIMALS = _config["default"].MAX_DECIMALS;
var DEFAULT_TIME_OUT = exports.DEFAULT_TIME_OUT = 900; // seconds
var WARNING_SIGN_OUT_TIME_SECONDS = exports.WARNING_SIGN_OUT_TIME_SECONDS = 120;
var REGEXP_MAP = exports.REGEXP_MAP = {
  variableName: /^[a-zA-Z]+([ ]{0,1}[a-zA-Z0-9-_]+)*[ ]{0,1}$/,
  // alphanumeric, dash, space and underscore regular expression
  excellFile: /(\.xlsx)$/i
};
var FILE_ENCODING = exports.FILE_ENCODING = 'UTF-8';
var SIZE_UNIT = exports.SIZE_UNIT = {
  kb: 'KB',
  mb: 'MB'
};
var betaFeaturePrefix = exports.betaFeaturePrefix = 'betaFeature';
var TYPES = exports.TYPES = {
  OFF: 'OFF',
  ON: 'ON'
};
var getErrorMessage = exports.getErrorMessage = function getErrorMessage(error) {
  return R.path(['response', 'data', 'errors', 0, 'message'], error) || R.prop('message', error);
};
var getErrorStatus = exports.getErrorStatus = function getErrorStatus(error) {
  return R.path(['response', 'status'], error);
};
var media = exports.media = Object.keys(breakpoints).reduce(function (accumulator, breakpoint) {
  return R.assoc(breakpoint, function () {
    return (0, _styledComponents.css)(["@media (min-width:", "){", ";}"], R.prop(breakpoint, breakpoints), _styledComponents.css.apply(void 0, arguments));
  }, accumulator);
}, {});
var debounce = exports.debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function callable() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var context = this;
    var later = function laterCallable() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
var isLengthGreaterThan = exports.isLengthGreaterThan = R.curry(function (length, item) {
  return R.gt(R.length(item), length);
});
var isLengthSmallerThan = exports.isLengthSmallerThan = R.curry(function (length, item) {
  return R.lt(R.length(item), length);
});
var isTouchDevice = exports.isTouchDevice = function isTouchDevice() {
  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
};
var parseURLFromText = exports.parseURLFromText = function parseURLFromText(text) {
  return typeof text === 'string' ? "".concat(text, " ").replace(/(http|https|www|ftp)+[:.].*?(?=\s)/gi, function (item) {
    return "<a href=\"".concat(item, "\" target=\"_blank\">").concat(item, "</a>");
  }) : '';
};
var sortByPropCaseInsensitive = exports.sortByPropCaseInsensitive = function sortByPropCaseInsensitive(prop) {
  return R.sortBy(R.compose(R.toLower, R.toString, R.prop(prop)));
};
var scrollTo = exports.scrollTo = function scrollTo() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (typeof offset === 'number') return window.scrollTo({
    top: offset,
    behavior: 'smooth'
  });
  if (typeof offset === 'string') {
    var elem = document.querySelector(offset);
    if (!elem) return 0;
    return window.scrollTo({
      top: elem.getBoundingClientRect().top + window.scrollY,
      behavior: 'smooth'
    });
  }
  return 0;
};
var validateViaKey = exports.validateViaKey = function validateViaKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    key = _ref.key,
    value = _ref.value;
  return R.prop(key, REGEXP_MAP) && value && REGEXP_MAP[key].test(value);
};
var getSize = exports.getSize = function getSize(unit, size) {
  var unitIndex = UNITS.indexOf(unit.toLowerCase()) + 1;
  return size / Math.pow(1024, unitIndex);
};
var actionCreators = exports.actionCreators = function actionCreators(type) {
  for (var _len2 = arguments.length, argNames = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    argNames[_key2 - 1] = arguments[_key2];
  }
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    var action = {
      type: type
    };
    argNames.forEach(function (arg, index) {
      action[argNames[index]] = args[index];
    });
    return action;
  };
};
var noop = exports.noop = function noop() {};
var getCountryCode = exports.getCountryCode = function getCountryCode(_ref2) {
  var countries = _ref2.countries,
    country = _ref2.country;
  return R.prop('code')(R.find(R.propEq('value', country))(countries));
};

/* 
  toFixed handles rounding wrongfully hence this method
  of using Math.round of the value multiplied by 10 to the power
  of decimals.
*/
var decimalTransform = exports.decimalTransform = function decimalTransform(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_DECIMALS;
  if (!decimals) return Math.round(value);
  var multiplier = Math.pow(10, decimals);
  return (Math.round(value * multiplier) / multiplier).toFixed(decimals);
};
var floor = exports.floor = function floor(value) {
  return (0, _objects.isBlank)(value) ? null : Math.floor(value);
};
var ceil = exports.ceil = function ceil(value) {
  return (0, _objects.isBlank)(value) ? null : Math.ceil(value);
};
var ramdaMapIndexed = exports.ramdaMapIndexed = R.addIndex(R.map);
var convertDecimalToPercentage = exports.convertDecimalToPercentage = function convertDecimalToPercentage(value) {
  var fixedDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return parseFloat((value * 100).toFixed(fixedDecimals));
};
var isSwipeDisabled = exports.isSwipeDisabled = function isSwipeDisabled() {
  return !isTouchDevice() || window.innerWidth >= 768;
};
var isMobile = exports.isMobile = window.innerWidth >= breakpointsNumeric.mobile && window.innerWidth <= breakpointsNumeric.tabletLandscape;
var hasSpecialCharacters = exports.hasSpecialCharacters = function hasSpecialCharacters(text) {
  var format = /[%^+[\]]/;
  return format.test(text);
};
var hasOnlySpecialCharacters = exports.hasOnlySpecialCharacters = function hasOnlySpecialCharacters(text) {
  var pattern = /^[^a-zA-Z0-9]+$/;
  return pattern.test(text);
};
var hasDecimalsWithinValue = exports.hasDecimalsWithinValue = function hasDecimalsWithinValue(value) {
  if (typeof value === 'string') return value.includes('.');
  return !Number.isInteger(value);
};
var hasOnlyWhiteSpaces = exports.hasOnlyWhiteSpaces = function hasOnlyWhiteSpaces(string) {
  return /^\s+$/.test(string);
};

// slice text and do not break words
var shortenText = exports.shortenText = function shortenText(text, max) {
  return text && text.length > max ? text.split('\n').join('\n ').split('&nbsp;').join('&nbsp; ').slice(0, max).split(' ').slice(0, -1).join(' ') : text;
};
var getNumberSeparatorsForLocale = exports.getNumberSeparatorsForLocale = function getNumberSeparatorsForLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var referenceNumber = 123456.7;
  var formatted = referenceNumber.toLocaleString(locale);
  return {
    specialNumberFormat: formatted.length === 10,
    thousandSeparator: formatted.slice(-6, -5),
    decimalSeparator: formatted.slice(-2, -1)
  };
};
var removeNumberFormatting = exports.removeNumberFormatting = function removeNumberFormatting(number) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  if ((0, _objects.isBlank)(number)) return '';
  var sep = getNumberSeparatorsForLocale(locale);
  var thousandRegex = new RegExp(sep.thousandSeparator.match(/\s/) ? /\s/ : sep.thousandSeparator, 'g');
  return number.replace(thousandRegex, '').replace(sep.decimalSeparator, '.');
};
var stringToLocale = exports.stringToLocale = function stringToLocale(number) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var sep = getNumberSeparatorsForLocale(locale);
  var startingPos = number.length - 1;
  var thousandDigitsCount = 0;
  var formattedNumber = number;
  var decimalPos = number.indexOf('.');
  if (decimalPos !== -1) {
    startingPos = decimalPos - 1;
    formattedNumber = formattedNumber.replace('.', sep.decimalSeparator);
  }
  for (var index = startingPos; index >= 0; index -= 1) {
    thousandDigitsCount += 1;
    if (thousandDigitsCount === 3 && index !== 0 && formattedNumber[index - 1] !== '-') {
      thousandDigitsCount = sep.specialNumberFormat ? 1 : 0;
      formattedNumber = "".concat(formattedNumber.slice(0, index)).concat(sep.thousandSeparator).concat(formattedNumber.slice(index));
    }
  }
  return formattedNumber;
};
var formatNumber = exports.formatNumber = function formatNumber(number) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var hasDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if ((0, _objects.isBlank)(number)) return '';
  var transformedNumber = hasDecimals ? decimalTransform(number) : number;
  var value = typeof transformedNumber === 'number' ? transformedNumber.toString() : transformedNumber;
  return stringToLocale(value, locale);
};